import { ChangeEvent } from 'react';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import CustomTextField from '../../../../../CustomTextInput';
import Signature from '../../../../../signature/signature';
import {
    CertificateOfOrigin,
    CertificateOfOriginFormErrors
} from '../../../../../../interfaces/CertificateOfOrigin';

interface CertificateOfOriginStepTwoFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: CertificateOfOrigin;
    errors: CertificateOfOriginFormErrors;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
    setSignatureUrlBase64Chamber: (value: string) => void;
    signatureUrlBase64Chamber: string;
    totalGrossWeight: number;
}

const StepTwo = ({
    updateField,
    payload,
    errors,
    setSignatureUrlBase64,
    signatureUrlBase64,
    setSignatureUrlBase64Chamber,
    signatureUrlBase64Chamber,
    totalGrossWeight
}: CertificateOfOriginStepTwoFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <CustomTextField
                disabled
                id='certificateoforgin-totalAmount'
                label='Total gross weight (kg)'
                name='totalAmount'
                value={totalGrossWeight}
            />

            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />

            <div className='p-4 border border-appcolorfaintnine rounded-[12px]'>
                <p className='font-semibold text-steelBlue leading-[24px]'>
                    Declaration By The Chamber
                </p>
                <p className='text-midnightHaze leading-[20px]'>
                    The undersigned certifies on the basis of information
                    provided by the exporter name that to the best of it’s
                    knowledge and belief, the goods are of designated origin,
                    production or manufacture.
                </p>
            </div>

            <CustomTextField
                error={errors?.chamberPlaceOfIssue.length > 0}
                helperText={
                    errors?.chamberPlaceOfIssue.length > 0
                        ? errors?.chamberPlaceOfIssue
                        : undefined
                }
                required
                id='certificateoforgin-exporterPlaceOfIssue'
                label='Chamber Place of Issue'
                name='chamberPlaceOfIssue'
                value={payload?.chamberPlaceOfIssue}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('chamberPlaceOfIssue', e.target.value);
                }}
            />

            <Customdatepicker
                value={
                    payload?.chamberIssuedDate !== undefined
                        ? payload?.chamberIssuedDate
                        : null
                }
                id='quotation-chamberIssuedDate'
                label='Chamber Issued Date'
                name='chamberIssuedDate'
                updateField={updateField}
                error={errors?.chamberIssuedDate.length > 0}
                helperText={
                    errors?.chamberIssuedDate.length > 0
                        ? errors?.chamberIssuedDate
                        : undefined
                }
            />

            <CustomTextField
                error={errors?.chamberSignatoryCompany.length > 0}
                helperText={
                    errors?.chamberSignatoryCompany.length > 0
                        ? errors?.chamberSignatoryCompany
                        : undefined
                }
                required
                id='certificateoforgin-chamberSignatoryCompany'
                label='Chamber Signatory Company'
                name='chamberSignatoryCompany'
                value={payload?.chamberSignatoryCompany}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('chamberSignatoryCompany', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.chamberNameOfAuthorisedSignatory.length > 0}
                helperText={
                    errors?.chamberNameOfAuthorisedSignatory.length > 0
                        ? errors?.chamberNameOfAuthorisedSignatory
                        : undefined
                }
                required
                value={payload?.chamberNameOfAuthorisedSignatory}
                id='certificateoforgin-chamberNameOfAuthorisedSignatory'
                label='Chamber Name of Authorized Signature'
                name='chamberNameOfAuthorisedSignatory'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField(
                        'chamberNameOfAuthorisedSignatory',
                        e.target.value
                    );
                }}
            />

            <Signature
                label='Chamber Signature'
                name='chamberSignatureUrl'
                updateField={updateField}
                setSignatureUrlBase64={setSignatureUrlBase64Chamber}
                signatureUrlBase64={signatureUrlBase64Chamber}
            />

            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
            <div className='p-4 border border-appcolorfaintnine rounded-[12px]'>
                <p className='font-semibold text-steelBlue leading-[24px]'>
                    Declaration By The Exporter
                </p>
                <p className='text-midnightHaze leading-[20px]'>
                    I, the undersigned, being duly authorized by the Consignor,
                    and having made the necessary enquiries hereby certify that
                    based on the rules of origin of the country of destination,
                    all the goods listed originate in the country and place of
                    designated. I further declare that I will furnish to the
                    Customs authorities of the importing or their nominee, for
                    inspection at any time, such as evidence as may be required
                    for the purpose of verifying this certificate.
                </p>
            </div>

            <CustomTextField
                // select
                error={errors?.exporterPlaceOfIssue.length > 0}
                helperText={
                    errors?.exporterPlaceOfIssue.length > 0
                        ? errors?.exporterPlaceOfIssue
                        : undefined
                }
                required
                id='certificateoforgin-exporterPlaceOfIssue'
                label='Place of Issue'
                name='exporterPlaceOfIssue'
                value={payload?.exporterPlaceOfIssue}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('exporterPlaceOfIssue', e.target.value);
                }}
            />

            <Customdatepicker
                value={
                    payload?.exporterIssuedDate !== undefined
                        ? payload?.exporterIssuedDate
                        : null
                }
                id='quotation-issuedDate'
                label='Exporter Issued Date'
                name='exporterIssuedDate'
                updateField={updateField}
                error={errors?.exporterIssuedDate.length > 0}
                helperText={
                    errors?.exporterIssuedDate.length > 0
                        ? errors?.exporterIssuedDate
                        : undefined
                }
            />

            <CustomTextField
                error={errors?.exporterSignatoryCompany.length > 0}
                helperText={
                    errors?.exporterSignatoryCompany.length > 0
                        ? errors?.exporterSignatoryCompany
                        : undefined
                }
                required
                id='certificateoforgin-exporterSignatoryCompany'
                label='Signatory Company'
                name='exporterSignatoryCompany'
                value={payload?.exporterSignatoryCompany}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('exporterSignatoryCompany', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.exporterNameOfAuthorisedSignatory.length > 0}
                helperText={
                    errors?.exporterNameOfAuthorisedSignatory.length > 0
                        ? errors?.exporterNameOfAuthorisedSignatory
                        : undefined
                }
                required
                id='certificateoforgin-exporterNameOfAuthorisedSignatory'
                label='Name of Authorized Signature'
                name='exporterNameOfAuthorisedSignatory'
                value={payload?.exporterNameOfAuthorisedSignatory}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField(
                        'exporterNameOfAuthorisedSignatory',
                        e.target.value
                    );
                }}
            />

            <Signature
                name='exporterSignatureUrl'
                updateField={updateField}
                setSignatureUrlBase64={setSignatureUrlBase64}
                signatureUrlBase64={signatureUrlBase64}
            />
        </div>
    );
};

export default StepTwo;
